/*
  CRO2610 plant sets (sections/cro2610-sets.liquid): the list of sets and one set opened in the same page.

  A set is up to four plants, each a place with a plant size and a list of plants, best first; the first one in
  stock fills the place (a plant in stock before a pre-order one) and the others are stand-ins and swap choices.
  The shopper has one pot style and one colour for the whole set, already chosen when the set opens: every plant
  gets that style's pot for its own size, so the pots always match. A pot style is only offered when it has a pot
  for every plant in the set, and a colour only when every pot needed is in stock.

  Repotting choices, matching trays and the wooden plant stands follow the pot picker's own table and rules
  (window.CV3_BUNDLE_VARIANTS, window.CV3_SET.allows, and window.CV3_STANDS for which stand fits which pot),
  so both offer the same things. Stands: each pot gets the closest-fitting stand in one colour for the whole set.

  What goes into the cart is the real plants, pots and services, written with the cart's contract for a
  plant + pot set (window.CV3_SET, snippets/cv3-bundle-variants.liquid), so the cart shows each plant with its pot
  as one set. Every line also carries
    _io_set     the set's name            (which set it was bought as)
    _io_set_id  one id per set added      (which lines belong to the same purchase of it)

  The picture is built from the cut-out photos and heights in cm that the pot picker's preview uses. A plant or pot
  without them is shown as its normal photo in a tile.

  A planter box set (the set has a "box") is one box that holds every plant. The box in the colour chosen takes the
  place of the pot style, a plant can go in several times while its stock lasts, there are no trays or stands, and
  repotting is charged once for the box, or for each plant by its size (the set says which). It is not a plant + pot
  set, so it goes into the cart as plain lines of its own kind: the box, each plant once with how many of it go in
  (3 x Bamboo Palm is one line of 3), and the repotting. Every line carries _io_box_id (one id per box added),
  _io_box (the box's name) and _io_box_role (box, plant or repot); the cart draws them as one planter box set
  (buildBoxLi in assets/cv3-cart-drawer.js, snippets/cv3-cart-page-box.liquid).

  An artificial set (the set is marked "artificial") is sold as it is: no pots, repotting, trays or stands are
  offered, the page says "artificial", and each plant goes into the cart as a line of its own. The store sells its
  artificial plants without the pot picker, and the cart only shows a pot under a live plant.
*/
(function () {
  'use strict';
  if (window.__twsReady) return;
  window.__twsReady = 2;

  var doc = document;
  var BAND = { XS: 'xs_s', S: 's', M: 'm', L: 'l', XL: 'xl', XXL: 'xxl' };
  var SIZE_WORD = { XS: 'XS', S: 'Small', M: 'Medium', L: 'Large', XL: 'XL', XXL: 'XXL' };
  var SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  var BIG = { XL: 1, XXL: 1 };   // the plant sizes a planter box holds only a few of
  var SINK = 0.12;   // how far a plant sits into its pot, as a share of the pot's height
  var LAP = 0.22;    // how much neighbours overlap in the group picture, as a share of the narrower one

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var c = Math.round(cents), neg = c < 0;
    c = Math.abs(c);
    var s = (c % 100 ? (c / 100).toFixed(2) : String(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (neg ? '-' : '') + '$' + s;
  }
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ' ').trim(); }
  function flat(v) { return v == null ? '' : (Array.isArray(v) ? v.join('') : String(v)); }
  function merge() {
    var out = {};
    for (var i = 0; i < arguments.length; i++) {
      var o = arguments[i] || {};
      Object.keys(o).forEach(function (k) { if (o[k] != null && o[k] !== '') out[k] = o[k]; });
    }
    return out;
  }
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function sized(url, w) {
    if (!url) return '';
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function isWide() { return !!(window.matchMedia && window.matchMedia('(min-width: 990px)').matches); }
  // "Bird of Paradise (1.1-1.6m)" → "Bird of Paradise"; "Money Tree - XL/XXL" → "Money Tree"; "ZZ Plant - Medium" → "ZZ Plant"
  function plantName(o) {
    var t = String(o.title || '');
    var out = t.replace(/\s*\((?:[\d.\s\-–m]|to)+\)\s*$/i, '');
    out = out.replace(/(?:\s+|\s*[-–]\s*)(?:XXL|XL|XS|S|M|L)(?:\s*\/\s*(?:XXL|XL|XS|S|M|L))*\s*$/, '');
    out = out.replace(/\s*[-–]\s*(?:Mini|Small|Medium|Large)\s*$/i, '');
    return out.trim() || t;
  }
  // "grow pot / 1.5m - XXL" → "1.5m - XXL"
  function plantBit(o) {
    var v = String(o.vt || '');
    if (/^default title$/i.test(v.trim())) return '';
    return v.replace(/grow (?:pot|bag)(?:\s*\/\s*(?:pot|bag))?/ig, '').replace(/\((?:special|launch|limited)[^)]*\)/ig, '').replace(/^[\s\/\-–]+|[\s\/\-–]+$/g, '').replace(/\s{2,}/g, ' ');
  }
  // a planter box's size as its option names it: "100x45x45" → "100 × 45 × 45 cm"
  function boxSize(hb) {
    var s = hb ? String(hb.v.size || '').trim() : '';
    return /^\d+(?:\s*x\s*\d+)+$/i.test(s) ? s.split(/\s*x\s*/i).join(' × ') + ' cm' : s;
  }
  // ["Bamboo Palm", "Bamboo Palm", "Fern"] → ["2 × Bamboo Palm", "Fern"]
  function counted(names) {
    var seen = [], n = {};
    names.forEach(function (x) { if (seen.indexOf(x) < 0) seen.push(x); n[x] = (n[x] || 0) + 1; });
    return seen.map(function (x) { return n[x] > 1 ? n[x] + ' × ' + x : x; });
  }

  /* ------------------------------------------------------------------ what the page was given */
  function Env(data) {
    this.data = data;
    this.styles = (data.styles || []).filter(Boolean).map(function (st) {
      st.colours = (st.colours || []).filter(Boolean);
      st.pots = st.pots || {};
      Object.keys(st.pots).forEach(function (k) { st.pots[k].v = (st.pots[k].v || []).filter(Boolean); });
      return st;
    });
    this.sets = (data.sets || []).filter(Boolean).map(function (s) {
      s.places = (s.places || []).filter(Boolean).map(function (pl) { pl.opts = (pl.opts || []).filter(Boolean); return pl; });
      if (s.box) { s.box.v = (s.box.v || []).filter(Boolean); if (!s.box.v.length) s.box = null; }
      return s;
    });
    this.lists = {};
  }
  // more plants of one size, fetched once when the shopper asks for them
  Env.prototype.plants = function (size) {
    var self = this, handle = (this.data.plantColl || {})[size];
    if (!handle) return Promise.resolve([]);
    if (!this.lists[size]) {
      this.lists[size] = fetch('/collections/' + encodeURIComponent(handle) + '?section_id=cro2610-set-plants', { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var box = doc.createElement('div');
          box.innerHTML = html;
          var node = box.querySelector('script[data-tws-plants]'), d = node ? JSON.parse(node.textContent) : null;
          return d ? (d.opts || []).filter(Boolean) : [];
        })
        .catch(function () { delete self.lists[size]; return []; });
    }
    return this.lists[size];
  };

  /* ------------------------------------------------------------------ the set: what is in it and what it costs */
  function Model(set, env) {
    var self = this;
    this.set = set;
    this.env = env;
    this.styleKey = '';
    this.colour = '';
    this.bare = false;         // the shopper chose "no pots"
    this.repot = true;
    this.repotChoice = '';     // the name of a repotting choice; empty = the standard one
    this.tray = false;
    this.stand = false;
    this.standColour = '';     // the stand colour chosen; empty = the one that fits most of the pots
    this.rows = [];
    // a planter box set: one box, in the colour chosen, holds every plant, and a place can hold several plants
    this.box = boxStyle(set);
    // an artificial set: the plants as they are, no pots or services
    this.plain = !this.box && !!set.artificial;
    (set.places || []).forEach(function (pl, pi) {
      if (pl.addon) return;
      // a place can hold several plants: in a planter box the same plant while stock lasts, in any other set
      // that many different plants from its list, each in its own pot
      var n = Math.max(1, Number(pl.count) || 1);
      var same = self.box && n > 1 ? self.firstFor(pi, n) : null;
      for (var k = 0; k < n; k++) self.rows.push({ pi: pi, o: same || self.firstFree(pi, -1), label: pl.label, size: pl.size });
    });
    this.pickStyle(set.potStyle, set.potColour);
  }
  // the box of a planter box set, in the shape of a pot style: its colours, and one "pot" for every plant size
  function boxStyle(set) {
    var b = set.box, colours = [];
    if (!b || !(b.v || []).length) return null;
    b.v.forEach(function (v) { if (colours.indexOf(v.c) < 0) colours.push(v.c); });
    return { key: '__box', name: b.title, box: true, colours: colours, pots: { ALL: b } };
  }
  Model.prototype.buyable = function (o) { return !!(o && o.a && o.q > 0); };
  // how many places hold this plant (leaving out one place: the one being filled or swapped)
  Model.prototype.taken = function (o, except) {
    return this.rows.filter(function (r, i) { return i !== except && r.o && r.o.id === o.id; }).length;
  };
  // can this plant fill one more place? A set of pots holds a plant once; a planter box can hold it again while
  // its stock lasts
  Model.prototype.free = function (o, except) {
    var n = this.taken(o, except);
    return this.box ? n < o.q : n === 0;
  };
  // the first plant of a place that can be bought and can still go in: one in stock before a pre-order one
  // (a pre-order plant in the cart switches off the delivery date choice for the whole order)
  // how many of a plant are still in stock once the set's other places have taken theirs (the rest of what a
  // pre-order plant can give is pre-order). Plants tagged "preorder-plants" are the only pre-orders (Sam, 2026-10-22)
  Model.prototype.stockLeft = function (o, except) {
    var s = o.s != null ? Number(o.s) : (o.pre ? 0 : Number(o.q) || 0);
    return s - this.taken(o, except);
  };
  // is this place's plant a pre-order? Every plant of the same kind in the set counts against its stock, in order
  Model.prototype.isPre = function (row) {
    var o = row && row.o;
    if (!o) return false;
    var s = o.s != null ? Number(o.s) : (o.pre ? 0 : 999), at = this.rows.indexOf(row), before;
    if (at < 0) before = this.taken(o, row.except == null ? -1 : row.except);
    else before = this.rows.slice(0, at).filter(function (r) { return r.o && r.o.id === o.id; }).length;
    return before >= s;
  };
  Model.prototype.firstFree = function (pi, except) {
    var opts = this.set.places[pi].opts || [], i;
    for (i = 0; i < opts.length; i++) if (this.buyable(opts[i]) && this.stockLeft(opts[i], except) > 0 && this.free(opts[i], except)) return opts[i];
    for (i = 0; i < opts.length; i++) if (this.buyable(opts[i]) && this.free(opts[i], except)) return opts[i];
    return null;
  };
  // a place that holds several plants starts with the same plant in each: the first with enough stock for all
  Model.prototype.firstFor = function (pi, n) {
    var self = this, can = (this.set.places[pi].opts || []).filter(function (o) { return self.buyable(o) && o.q - self.taken(o, -1) >= n; });
    return can.filter(function (o) { return self.stockLeft(o, -1) >= n; })[0] || can[0] || null;
  };
  Model.prototype.live = function () { return this.rows.filter(function (r) { return !!r.o; }); };
  Model.prototype.sizes = function () {
    var out = [];
    this.live().forEach(function (r) { if (out.indexOf(r.size) < 0) out.push(r.size); });
    return out;
  };
  Model.prototype.style = function () {
    var key = this.styleKey;
    if (this.box) return key ? this.box : null;
    return key ? (this.env.styles.filter(function (st) { return st.key === key; })[0] || null) : null;
  };
  // the pot of a style, in a colour, for a plant size (a planter box is the same one whatever the size)
  Model.prototype.hit = function (style, label, size) {
    var pot = style && style.pots ? (style.box ? style.pots.ALL : style.pots[size]) : null;
    if (!pot) return null;
    var v = pot.v.filter(function (x) { return x.c === label; })[0];
    return v ? { pot: pot, v: v } : null;
  };
  // pots always match: a style is only offered when it has a pot for every plant size in the set
  Model.prototype.fits = function (style, extraSize) {
    var sizes = this.sizes();
    if (extraSize && sizes.indexOf(extraSize) < 0) sizes.push(extraSize);
    return sizes.length > 0 && sizes.every(function (s) { return style.pots[s] && style.pots[s].v.length > 0; });
  };
  // 'ok', or why this colour of the style cannot be supplied for the set today
  Model.prototype.colourState = function (label, style) {
    var self = this, need = {}, bad = '';
    style = style || this.style();
    if (!style) return 'none';
    if (style.box) {
      var hb = this.hit(style, label, '');
      return hb && hb.v.a && hb.v.q > 0 ? 'ok' : 'sold out';
    }
    this.live().forEach(function (row) {
      var h = self.hit(style, label, row.size), word = SIZE_WORD[row.size] || row.size;
      if (!h) { bad = bad || 'not made in the ' + word + ' size'; return; }
      need[h.v.id] = (need[h.v.id] || 0) + 1;
      if (!h.v.a || h.v.q < need[h.v.id]) bad = bad || 'sold out in the ' + word + ' size';
    });
    return bad || 'ok';
  };
  Model.prototype.okColours = function (style) {
    var self = this;
    return (style.colours || []).filter(function (c) { return self.colourState(c, style) === 'ok'; });
  };
  Model.prototype.fitStyles = function () {
    var self = this;
    if (this.box) return this.live().length && this.okColours(this.box).length ? [this.box] : [];
    if (this.plain) return [];
    // a style made for one set ("only for sets that name this style") is offered to that set only
    return this.env.styles.filter(function (st) { return (!st.own || norm(st.name) === norm(self.set.potStyle) || st.key === norm(self.set.potStyle)) && self.fits(st) && self.okColours(st).length > 0; });
  };
  // choose the pot style (by name) and colour: what was asked for if it can be supplied, else what is chosen now,
  // else the first that can; no style at all leaves the plants in their nursery pots
  Model.prototype.pickStyle = function (name, colour) {
    var fit = this.fitStyles(), cur = this.styleKey, want = norm(name), pick = null;
    if (want) pick = fit.filter(function (st) { return norm(st.name) === want || st.key === want; })[0] || null;
    if (!pick && cur) pick = fit.filter(function (st) { return st.key === cur; })[0] || null;
    if (!pick) pick = fit[0] || null;
    if (!pick) { this.styleKey = ''; this.colour = ''; return; }
    this.styleKey = pick.key;
    var ok = this.okColours(pick), wantC = norm(colour), curC = this.colour;
    var c = ok.filter(function (x) { return norm(x) === wantC; })[0] || ok.filter(function (x) { return x === curC; })[0] || ok[0];
    this.colour = c;
  };
  // after the plants change: keep the chosen pots when they can still be supplied
  Model.prototype.settle = function () {
    if (this.bare) { this.styleKey = ''; this.colour = ''; return; }
    var st = this.style();
    this.pickStyle(st ? st.name : this.set.potStyle, this.colour || this.set.potColour);
  };
  Model.prototype.sizeOk = function (size) {
    if (this.box) return this.roomFor(size);
    var st = this.style();
    if (!st) return true;
    if (!st.pots[size] || !this.hit(st, this.colour, size)) return false;
    var h = this.hit(st, this.colour, size), self = this;
    var inUse = this.live().filter(function (r) { var x = self.hit(st, self.colour, r.size); return x && x.v.id === h.v.id; }).length;
    return h.v.a && h.v.q > inUse;
  };
  // room in a planter box for one more plant of this size: the set says how many plants it holds, and how many
  // of them can be XL or XXL
  Model.prototype.roomFor = function (size) {
    var b = this.set.box || {}, rows = this.live(), max = Number(b.max) || 0, tall = Number(b.maxTall) || 0;
    if (max && rows.length >= max) return false;
    if (tall && BIG[size] && rows.filter(function (r) { return !!BIG[r.size]; }).length >= tall) return false;
    return true;
  };
  // can the set go into the cart? It needs a plant, and a planter box set needs its box
  Model.prototype.ready = function () { return this.live().length > 0 && (!this.box || !!this.style()); };
  // the repotting for one plant size, in the kind chosen (the pot picker's table)
  Model.prototype.repotFor = function (band) {
    var r = ((window.CV3_BUNDLE_VARIANTS || {}).repot || {})[band], choice = this.repotChoice;
    if (!r || !r.id) return null;
    var opt = choice && r.options ? r.options.filter(function (x) { return x.label === choice; })[0] : null;
    return opt ? { id: opt.id, price: Number(opt.price) || 0, label: opt.label } : { id: r.id, price: Number(r.price) || 0, label: '' };
  };
  // a planter box whose repotting is charged once for the whole box, at one plant size's price (the set says which)
  Model.prototype.boxRepot = function (every) {
    var b = this.box ? this.set.box : null;
    if (!b || !b.repot || !(every || this.repot) || !this.live().length) return null;
    var h = this.style() ? this.hit(this.box, this.colour, '') : null, S = window.CV3_SET;
    if (!h || !h.v.a || (S && S.allows && !S.allows(h.pot.drn, h.pot.tray).repot)) return null;
    return this.repotFor(BAND[b.repot]);
  };
  Model.prototype.parts = function (row, all) {
    var o = row.o;
    if (!o) return null;
    var st = this.style(), h = st && this.colour ? this.hit(st, this.colour, row.size) : null;
    if (h && !h.v.a) h = null;
    var table = window.CV3_BUNDLE_VARIANTS || {}, band = BAND[row.size], inBox = !!this.box;
    var allow = h && window.CV3_SET && window.CV3_SET.allows ? window.CV3_SET.allows(h.pot.drn, h.pot.tray) : { repot: !!h, tray: false };
    var repot = null, tray = null, stand = null;
    // in a planter box a plant has no tray or stand of its own, and no repotting of its own when the box is
    // charged one repotting (boxRepot)
    if (inBox) { allow.tray = false; if (this.set.box.repot) allow.repot = false; }
    if (h && allow.repot && (all || this.repot)) repot = this.repotFor(band);
    if (h && allow.tray && (all || this.tray)) {
      var t = (table.tray || {})[band];
      if (t && t.id) tray = { id: t.id, price: Number(t.price) || 0 };
    }
    if (h && !inBox && (all || this.stand)) {
      var plan = this.standPlan(this.rows.indexOf(row) < 0 ? row : null).filter(function (x) { return x.row === row; })[0];
      if (plan && plan.stand) stand = { id: plan.stand.id, price: plan.stand.price, size: plan.stand.size, colour: plan.stand.colour };
    }
    var own = h && !inBox ? h : null;   // the plant's own pot; the box of a planter box set is counted once, in sums()
    return {
      plant: o, pre: this.isPre(row), size: row.size, label: row.label, pot: own ? own.pot : null, potVar: own ? own.v : null,
      box: inBox && h ? h.v : null,
      repot: repot, tray: tray, stand: stand,
      total: o.p + (own ? own.v.p : 0) + (repot ? repot.price : 0) + (tray ? tray.price : 0) + (stand ? stand.price : 0)
    };
  };
  // the stands that fit a plant's pot (window.CV3_STANDS, the list the product page's pot picker uses)
  Model.prototype.standFits = function (row) {
    if (this.box) return [];
    var SD = window.CV3_STANDS, st = this.style();
    var h = SD && st && this.colour && row.o ? this.hit(st, this.colour, row.size) : null;
    return h && h.v.a ? SD.forPot(flat(h.pot.w), h.v.t, { title: h.pot.title, inner: flat(h.pot.inner), size: row.size }) : [];
  };
  // the stand colours this set's pots can have, the colour that fits most pots first
  Model.prototype.standColours = function () {
    var self = this, seen = [], count = {};
    this.live().forEach(function (row) {
      var had = {};
      self.standFits(row).forEach(function (s) {
        if (had[s.colour] || !(s.q > 0)) return;
        had[s.colour] = 1;
        if (seen.indexOf(s.colour) < 0) seen.push(s.colour);
        count[s.colour] = (count[s.colour] || 0) + 1;
      });
    });
    return seen.map(function (c, i) { return { c: c, n: count[c], i: i }; })
      .sort(function (a, b) { return b.n - a.n || a.i - b.i; }).map(function (x) { return x.c; });
  };
  Model.prototype.standColourNow = function () {
    var list = this.standColours();
    return list.indexOf(this.standColour) > -1 ? this.standColour : (list[0] || '');
  };
  // which stand each plant's pot gets: the closest fit in the chosen colour, while that stand's stock lasts.
  // `extra` = a plant that is not in the set yet (the price shown before it is added)
  Model.prototype.standPlan = function (extra) {
    var self = this, used = {}, col = this.standColourNow();
    return this.rows.concat(extra ? [extra] : []).map(function (row) {
      var pick = self.standFits(row).filter(function (s) { return s.colour === col && (used[s.id] || 0) < s.q; })[0] || null;
      if (pick) used[pick.id] = (used[pick.id] || 0) + 1;
      return { row: row, stand: pick };
    });
  };
  Model.prototype.all = function (every) {
    var self = this;
    return this.rows.map(function (row) { return self.parts(row, every); }).filter(Boolean);
  };
  Model.prototype.hasPre = function () { return this.all().some(function (p) { return !!p.pre; }); };
  // a set with a pre-order plant goes into the cart only once the shopper has agreed to the pre-order timeline
  Model.prototype.canAdd = function () { return this.ready() && (!this.hasPre() || !!this.agreed); };
  // every place of the set as designed has a plant, counting how many of each plant the set needs against stock,
  // and a planter box set has its box: only such sets are shown in the list
  Model.prototype.whole = function () {
    return this.rows.length > 0 && this.rows.every(function (r) { return !!r.o; }) && (!this.box || !!this.style());
  };
  // `every` = as if repotting, trays and stands were all ticked (what each would cost for this set)
  Model.prototype.sums = function (every) {
    var s = { plants: 0, pots: 0, repot: 0, tray: 0, stand: 0, total: 0, count: 0, potCount: 0, repotCount: 0, trayCount: 0, standCount: 0 };
    this.all(every).forEach(function (p) {
      s.count++; s.plants += p.plant.p;
      if (p.potVar) { s.pots += p.potVar.p; s.potCount++; }
      if (p.repot) { s.repot += p.repot.price; s.repotCount++; }
      if (p.tray) { s.tray += p.tray.price; s.trayCount++; }
      if (p.stand) { s.stand += p.stand.price; s.standCount++; }
    });
    if (this.box && s.count) {
      // one box for all the plants, and one repotting when the box is charged that way
      var hb = this.style() ? this.hit(this.box, this.colour, '') : null, once = this.boxRepot(every);
      if (hb && hb.v.a) { s.pots += hb.v.p; s.potCount = 1; }
      if (once) { s.repot += once.price; s.repotCount++; }
    }
    s.total = s.plants + s.pots + s.repot + s.tray + s.stand;
    return s;
  };
  // the repotting choices of the plant sizes in the set (the large sizes have several), standard first
  Model.prototype.repotChoices = function () {
    var table = (window.CV3_BUNDLE_VARIANTS || {}).repot || {}, out = [];
    var once = this.box ? this.set.box.repot : '';
    (once ? [BAND[once]] : this.live().map(function (row) { return BAND[row.size]; })).forEach(function (band) {
      var r = table[band];
      ((r && r.options) || []).forEach(function (o, i) {
        if (!out.some(function (x) { return x.label === o.label; })) out.push({ label: o.label, first: i === 0 });
      });
    });
    return out;
  };
  // what repotting the whole set costs with one kind chosen
  Model.prototype.repotCost = function (choice) {
    var keepChoice = this.repotChoice, keepOn = this.repot, cost;
    this.repotChoice = choice || ''; this.repot = true;
    cost = this.sums().repot;
    this.repotChoice = keepChoice; this.repot = keepOn;
    return cost;
  };
  Model.prototype.swapChoices = function (ri) {
    var self = this, row = this.rows[ri];
    if (!row || row.pi < 0) return [];
    return (this.set.places[row.pi].opts || []).filter(function (o) { return self.buyable(o) && self.free(o, ri); });
  };
  // plants of the set that can be added now: the suggested extras first, then every stand-in not in the set
  Model.prototype.suggested = function () {
    var self = this, seen = {}, out = [];
    [true, false].forEach(function (addon) {
      self.set.places.forEach(function (pl) {
        if (!!pl.addon !== addon) return;
        (pl.opts || []).forEach(function (o) {
          if (!self.buyable(o) || seen[o.id] || !self.free(o, -1) || !self.sizeOk(pl.size)) return;
          seen[o.id] = 1;
          out.push(merge(o, { size: pl.size }));
        });
      });
    });
    return out.filter(function (o) { return self.stockLeft(o, -1) > 0; }).concat(out.filter(function (o) { return self.stockLeft(o, -1) <= 0; }));
  };
  Model.prototype.quote = function (o, size, except) {
    return this.parts({ pi: -1, o: o, label: '', size: size, except: except });
  };
  Model.prototype.add = function (o, size) {
    this.rows.push({ pi: -1, o: o, label: (SIZE_WORD[size] || size) + ' plant', size: size });
    this.settle();
  };
  // the cart lines: for each plant its own plant + pot set, exactly as the product page writes one
  Model.prototype.items = function () {
    var S = window.CV3_SET || null, items = [], env = this.env, asIs = this.plain;
    var tag = { _io_set: this.set.name, _io_set_id: 's_' + Math.random().toString(36).slice(2, 8) };
    if (this.box) return this.boxItems(S, tag);
    this.all().forEach(function (p) {
      var coll = (env.data.potColl || {})[p.size] || '';
      if (!p.potVar || !S) {
        // a live plant on its own says its size and where its pots are (the cart offers a pot); an artificial one does not
        var plain = !asIs && S && S.plain ? S.plain(p.size, coll) : {};
        items.push({ id: p.plant.id, quantity: 1, properties: merge(plain, tag, p.pre ? { _io_preorder: 'agreed' } : {}) });
        if (p.potVar) items.push({ id: p.potVar.id, quantity: 1, properties: merge(tag) });
        return;
      }
      var repotId = p.repot ? p.repot.id : '', trayId = p.tray ? p.tray.id : '';
      var vis = {};
      if (p.plant.vis) vis.ph = p.plant.vis;
      if (p.plant.hcm) vis.vh = String(p.plant.hcm);
      var want = {
        paired: S.paired(p.pot.title, p.potVar.t), repot: !!repotId, tray: !!trayId,
        size: p.size, potCollection: coll, visual: Object.keys(vis).length ? JSON.stringify(vis) : ''
      };
      var id = S.id(p.plant.id, p.potVar.id, repotId, trayId);
      want.id = id;
      id = S.free(id, S.plant(want, tag));
      want.id = id;
      var spec = S.potSpec({
        photo: p.potVar.cut, visualHeight: p.potVar.hcm || '', material: p.pot.mat, drainage: p.pot.drn, tray: p.pot.tray,
        width: p.pot.w, height: p.pot.h, inner: p.pot.inner
      });
      items.push({ id: p.plant.id, quantity: 1, properties: merge(S.plant(want, tag), p.pre ? { _io_preorder: 'agreed' } : {}) });
      items.push({ id: p.potVar.id, quantity: 1, properties: merge({ _io_bundle_id: id, _io_bundle_role: 'pot' }, spec ? { _io_pot_spec: spec } : {}, tag) });
      if (repotId) items.push({ id: repotId, quantity: 1, properties: merge({ _io_bundle_id: id, _io_bundle_role: 'repot', _io_service_type: 'repotting' }, tag) });
      if (trayId) items.push({ id: trayId, quantity: 1, properties: merge({ _io_bundle_id: id, _io_bundle_role: 'tray', _io_service_type: 'tray' }, tag) });
      if (p.stand) items.push({ id: p.stand.id, quantity: 1, properties: merge({ _io_bundle_id: id, _io_bundle_role: 'addon' }, tag) });
    });
    return items;
  };
  // A planter box set in the cart: the box, each plant once with how many of it go into the box, and the repotting.
  // Plain lines, tied together by _io_box_id: a plant that goes in three times is one line of 3, which is how it
  // reads in the cart, at checkout and on the order.
  Model.prototype.boxItems = function (S, tag) {
    var items = [], parts = this.all(), n = parts.length;
    var st = this.style(), h = st ? this.hit(st, this.colour, '') : null;
    if (!n || !h || !h.v.a) return items;
    var name = S && S.paired ? S.paired(h.pot.title, h.v.t) : h.pot.title + ' \u2014 ' + h.v.t;
    var base = merge(tag, { _io_box_id: tag._io_set_id, _io_box: name });
    var line = function (id, qty, role, extra) { items.push({ id: id, quantity: qty, properties: merge(base, { _io_box_role: role }, extra) }); };
    var tally = function (list) {
      var order = [], count = {};
      list.forEach(function (id) { if (!count[id]) { count[id] = 0; order.push(id); } count[id]++; });
      return order.map(function (id) { return { id: id, n: count[id] }; });
    };
    line(h.v.id, 1, 'box', { _io_box_plants: String(n) });
    tally(parts.map(function (p) { return p.plant.id; })).forEach(function (x) {
      var pre = parts.filter(function (p) { return p.plant.id === x.id && p.pre; }).length;
      line(x.id, x.n, 'plant', pre ? { _io_preorder: pre + ' of ' + x.n + ' on pre-order, agreed' } : {});
    });
    var once = this.boxRepot();
    if (once) line(once.id, 1, 'repot');
    else tally(parts.filter(function (p) { return !!p.repot; }).map(function (p) { return p.repot.id; })).forEach(function (x) { line(x.id, x.n, 'repot'); });
    return items;
  };

  /* ------------------------------------------------------------------ the picture */
  function canCompose(p) {
    return !!(p.plant.cut && p.plant.hcm > 0 && p.plant.ar > 0 && p.potVar && p.potVar.cut && p.potVar.hcm > 0 && p.potVar.ar > 0);
  }
  function measure(p) {
    var ph = p.plant.hcm, qh = p.potVar.hcm, sink = qh * SINK;
    return { p: p, ph: ph, qh: qh, sink: sink, h: ph + qh - sink, w: Math.max(ph * p.plant.ar, qh * p.potVar.ar) };
  }
  function pairHtml(it, s) {
    return '<img class="tws-pp__plant" src="' + esc(it.p.plant.cut) + '" alt="' + esc(plantName(it.p.plant)) + '" style="height:' + (it.ph * s).toFixed(1) + 'px;margin-bottom:-' + (it.sink * s).toFixed(1) + 'px" loading="lazy" decoding="async">' +
      '<img class="tws-pp__pot" src="' + esc(sized(it.p.potVar.cut, 400)) + '" alt="" style="height:' + (it.qh * s).toFixed(1) + 'px" loading="lazy" decoding="async">';
  }
  // all plants standing together at their real heights, tallest at the back and in the middle
  function groupHtml(parts, W, H) {
    var items = parts.map(measure);
    var byH = items.slice().sort(function (a, b) { return b.h - a.h; });
    var line = [], laps = [], totalW = 0;
    byH.forEach(function (it, i) { it.z = i + 1; if (i % 2) line.unshift(it); else line.push(it); });
    line.forEach(function (it, i) {
      totalW += it.w;
      if (i) { laps[i] = LAP * Math.min(it.w, line[i - 1].w); totalW -= laps[i]; }
    });
    var s = Math.min(H / byH[0].h, W / totalW);
    return '<div class="tws-group">' + line.map(function (it, i) {
      return '<div class="tws-pp" style="z-index:' + it.z + (i ? ';margin-left:-' + (laps[i] * s).toFixed(1) + 'px' : '') + '">' + pairHtml(it, s) + '</div>';
    }).join('') + '</div>';
  }
  // a planter box set: can the plants be drawn standing in their box?
  function boxCanCompose(parts, v) {
    return !!(v && v.cut && v.hcm > 0 && v.ar > 0) && parts.length <= 5 &&
      parts.every(function (p) { return !!(p.plant.cut && p.plant.hcm > 0 && p.plant.ar > 0); });
  }
  // the plants side by side in one box at their real heights, the tallest in the middle and at the back
  function boxGroupHtml(parts, v, W, H) {
    var bh = v.hcm, bw = bh * v.ar, sink = bh * SINK;
    var items = parts.map(function (p) { return { p: p, h: p.plant.hcm, w: p.plant.hcm * p.plant.ar }; });
    var byH = items.slice().sort(function (a, b) { return b.h - a.h; }), line = [], minX = 0, maxX = bw;
    byH.forEach(function (it, i) { it.z = i + 1; if (i % 2) line.unshift(it); else line.push(it); });
    line.forEach(function (it, i) {
      it.cx = bw * (i + 0.5) / line.length;
      minX = Math.min(minX, it.cx - it.w / 2);
      maxX = Math.max(maxX, it.cx + it.w / 2);
    });
    var totalH = byH[0].h + bh - sink, s = Math.min(H / totalH, W / (maxX - minX));
    return '<div class="tws-boxpic" style="width:' + ((maxX - minX) * s).toFixed(1) + 'px;height:' + (totalH * s).toFixed(1) + 'px">' +
      line.map(function (it) {
        return '<img class="tws-boxpic__plant" src="' + esc(it.p.plant.cut) + '" alt="' + esc(plantName(it.p.plant)) + '" style="left:' + ((it.cx - it.w / 2 - minX) * s).toFixed(1) +
          'px;bottom:' + ((bh - sink) * s).toFixed(1) + 'px;height:' + (it.h * s).toFixed(1) + 'px;z-index:' + it.z + '" loading="lazy" decoding="async">';
      }).join('') +
      '<img class="tws-boxpic__box" src="' + esc(v.cut) + '" alt="" style="left:' + (-minX * s).toFixed(1) + 'px;width:' + (bw * s).toFixed(1) + 'px;height:' + (bh * s).toFixed(1) +
      'px;z-index:' + (line.length + 1) + '" loading="lazy" decoding="async"></div>';
  }
  function boxTileHtml(hb, th) {
    var src = hb.v.cut || hb.v.img;
    return '<div class="tws-tile tws-tile--photo tws-tile--box" style="height:' + Math.round(th) + 'px">' +
      (src ? '<img class="tws-tile__shot" src="' + esc(sized(src, 500)) + '" alt="' + esc(hb.pot.title) + '" loading="lazy" decoding="async">' : '') + '</div>';
  }
  function tileHtml(p, tw, th, small) {
    var cls = 'tws-tile' + (small ? ' tws-tile--s' : ''), style = ' style="height:' + Math.round(th) + 'px"';
    if (canCompose(p)) {
      var it = measure(p), pad = small ? 8 : 26;
      var s = Math.min((th - pad) / it.h, (tw - (small ? 6 : 12)) / it.w);
      return '<div class="' + cls + '"' + style + '><div class="tws-pp">' + pairHtml(it, s) + '</div></div>';
    }
    var pic = potImg(p.potVar);
    var chip = pic ? '<span class="tws-tile__pot">' + pic + '</span>' : '';
    return '<div class="' + cls + ' tws-tile--photo"' + style + '>' +
      (p.plant.img ? '<img class="tws-tile__shot" src="' + esc(sized(p.plant.img, small ? 200 : 500)) + '" alt="' + esc(plantName(p.plant)) + '" loading="lazy" decoding="async">' : '') + chip + '</div>';
  }
  function drawStage(el, model, tall) {
    if (!el) return;
    var parts = model.all(), n = parts.length, box = el.clientWidth || 340, wide = isWide() && tall, gap = 8;
    if (!n) { el.className = 'tws-stage'; el.style.height = ''; el.innerHTML = '<p class="tws-stage__empty">Add a plant to see your set.</p>'; return; }
    var hb = model.box && model.style() ? model.hit(model.box, model.colour, '') : null;
    var boxed = !!hb && boxCanCompose(parts, hb.v);
    var group = !model.box && n <= 5 && parts.every(canCompose);
    // some plants have no cut-out: every plant gets its own tile, on one backdrop that suits the studio photos
    var mixed = !group && !boxed && parts.some(canCompose);
    el.className = 'tws-stage' + (group || boxed ? '' : ' tws-stage--tiles') + (mixed ? ' tws-stage--mixed' : '');
    if (group || boxed) {
      var total = tall ? (wide ? Math.min(560, Math.max(380, box * 0.9)) : Math.min(430, Math.max(270, box * 0.86))) : Math.min(250, Math.max(190, box * 0.62));
      el.style.height = Math.round(total) + 'px';
      el.innerHTML = boxed ? boxGroupHtml(parts, hb.v, Math.max(200, box - 28), total - 40) : groupHtml(parts, Math.max(200, box - 28), total - 40);
      return;
    }
    // tiles: on a phone side by side, on a desktop in rows as the set grows. A planter box takes the first tile,
    // and a full box (seven tiles or more) stays in two rows on a phone and three on a desktop
    var count = n + (hb ? 1 : 0), many = !!model.box && count > 6;
    var cols = wide ? (count <= 3 ? count : (count === 4 ? 2 : 3)) : (count <= 4 ? count : 3);
    if (many) cols = wide ? (count === 9 ? 3 : 4) : Math.ceil(count / 2);
    var tw = (box - gap * (cols - 1)) / cols, rowsN = Math.ceil(count / cols);
    var th = tall ? (wide ? Math.min(380, Math.max(220, tw * 1.3)) : Math.min(300, Math.max(150, tw * 1.55))) : Math.min(210, Math.max(150, tw * 1.55));
    if (many) th = wide ? Math.min(th, Math.max(120, (600 - gap * (rowsN - 1)) / rowsN)) : Math.min(th, Math.max(96, tw * 1.55));
    el.style.height = 'auto';
    el.innerHTML = '<div class="tws-tiles" style="grid-template-columns:repeat(' + cols + ',minmax(0,1fr))">' +
      (hb ? boxTileHtml(hb, th) : '') + parts.map(function (p) { return tileHtml(p, tw, th, false); }).join('') + '</div>';
  }

  /* ------------------------------------------------------------------ pots, plants, finishing touches */
  // a picture of a pot: its cut-out when it has one, else its product photo (drawn to fill its frame)
  function potImg(v, extra) {
    if (!v || !(v.cs || v.img)) return '';
    return '<img' + (v.cs ? '' : ' class="is-photo"') + ' src="' + esc(v.cs || v.img) + '" alt="" loading="lazy"' + (extra || '') + '>';
  }
  function potPic(model, style, label) {
    var pic = '';
    if (style && style.box) { var hb = model.hit(style, label, ''); return hb ? potImg(hb.v) : ''; }
    ['XXL', 'XL', 'L', 'M', 'S', 'XS'].some(function (size) {
      if (model.sizes().indexOf(size) < 0) return false;
      var h = model.hit(style, label, size);
      if (h && (h.v.cs || h.v.img)) { pic = potImg(h.v); return true; }
      return false;
    });
    return pic;
  }
  function colourChips(model) {
    var style = model.style();
    if (!style) return { html: '', off: [] };
    var off = [], html = '';
    (style.colours || []).forEach(function (c) {
      var state = model.colourState(c, style), ok = state === 'ok', on = ok && c === model.colour, pic = potPic(model, style, c);
      if (!ok) off.push(c + ' is ' + state + ' today');
      html += '<button type="button" class="tws-colour' + (on ? ' is-on' : '') + (ok ? '' : ' is-off') + '" data-tws-colour="' + esc(c) + '" aria-pressed="' + (on ? 'true' : 'false') + '"' +
        (ok ? '' : ' aria-disabled="true"') + ' aria-label="' + esc(c + (ok ? '' : ', not available today')) + '">' +
        (pic || '<span class="tws-colour__txt">' + esc(c.slice(0, 2)) + '</span>') + '</button>';
    });
    return { html: html, off: off };
  }
  function check(attr, on, title, price, note, extra) {
    return '<div class="tws-check"><label class="tws-check__main"><input type="checkbox" ' + attr + (on ? ' checked' : '') + '>' +
      '<span class="tws-check__box" aria-hidden="true"></span>' +
      '<span class="tws-check__txt"><strong>' + esc(title) + '</strong><em>' + esc(price) + '</em>' + (note ? '<small>' + esc(note) + '</small>' : '') + '</span></label>' +
      (extra || '') + '</div>';
  }
  function appHtml(model, L) {
    var style = model.style(), sums = model.sums(), every = model.sums(true), html = '';
    var inBox = !!model.box, hb = inBox && style ? model.hit(style, model.colour, '') : null;
    var canChange = !inBox && (model.fitStyles().length > 1 || (model.set.noPots && !!style) || (!style && model.fitStyles().length > 0));

    var asIs = !!model.plain;
    if (!asIs) html += '<div class="tws-step"><h2 class="tws-step__h"><span class="tws-step__n">1</span>' + esc(inBox ? (L.boxStep || 'Your planter box') : (L.step1 || 'Your pots')) + '</h2>';
    if (asIs) {
      // an artificial set has no pots step
    } else if (style) {
      var cc = colourChips(model), pic = potPic(model, style, model.colour);
      var potNow = inBox
        ? '<strong>' + esc(style.name) + ' in ' + esc(model.colour) + '</strong><span>' + esc([boxSize(hb), hb ? money(hb.v.p) : '', L.boxNote || 'One box holds all the plants.'].filter(Boolean).join(' · ')) + '</span>'
        : '<strong>' + esc(style.name) + ' pots in ' + esc(model.colour) + '</strong><span>One for each plant, in the size it needs.</span>';
      html += '<div class="tws-potnow">' + (pic ? '<span class="tws-potnow__pic">' + pic + '</span>' : '') +
        '<span class="tws-potnow__txt">' + potNow + '</span>' +
        (canChange ? '<button type="button" class="tws-mini" data-tws-styles>Change</button>' : '') + '</div>';
      html += '<div class="tws-colours" role="group" aria-label="' + (inBox ? 'Box colour' : 'Pot colour') + '">' + cc.html + '</div>';
      if (cc.off.length) html += '<p class="tws-note tws-note--box">' + esc(cc.off.join('. ')) + '.</p>';
    } else if (inBox) {
      html += '<div class="tws-potnow"><span class="tws-potnow__txt"><strong>' + esc(model.box.name) + '</strong><span>' + (model.live().length ? 'Sold out today.' : 'Add a plant to choose the box.') + '</span></span></div>';
    } else {
      html += '<div class="tws-potnow"><span class="tws-potnow__txt"><strong>' + esc(L.noPots || 'No pots') + '</strong><span>' + esc(L.noPotsNote || 'Plants arrive in their nursery pots.') + '</span></span>' +
        (canChange ? '<button type="button" class="tws-mini" data-tws-styles>Add pots</button>' : '') + '</div>';
    }
    if (!asIs) html += '</div>';

    html += '<div class="tws-step"><h2 class="tws-step__h"><span class="tws-step__n">' + (asIs ? 1 : 2) + '</span>' + esc(L.step2 || 'Your plants') + '</h2><ul class="tws-rows">';
    model.rows.forEach(function (row, ri) {
      var p = model.parts(row);
      if (!p) {
        html += '<li class="tws-row tws-row--out"><div class="tws-row__txt"><span class="tws-row__label">' + esc(row.label) + '</span><strong>Out of stock today</strong></div>' +
          '<div class="tws-row__acts"><button type="button" class="tws-x" data-tws-remove="' + ri + '" aria-label="Remove">×</button></div></li>';
        return;
      }
      var bit = plantBit(p.plant), meta = [], extras = [];
      if (bit) meta.push(bit);
      if (p.repot) extras.push('repotted');
      if (p.tray) extras.push('tray');
      if (p.stand) extras.push('stand');
      if (p.box) meta.push(p.repot || model.boxRepot() ? 'planted in the box' : 'in its nursery pot');
      else if (p.potVar) meta.push('in ' + (style && style.own ? p.pot.title : (style ? style.name : '') + ' ' + (SIZE_WORD[p.size] || p.size)) + (extras.length ? ', ' + extras.join(', ') : ''));
      else meta.push(asIs ? 'artificial plant' : 'in its nursery pot');
      html += '<li class="tws-row">' + tileHtml(p, 62, 84, true) +
        '<div class="tws-row__txt"><span class="tws-row__label">' + esc(p.label) + (p.pre ? ' <b class="tws-pre">Pre-order</b>' : '') + '</span><strong>' + esc(plantName(p.plant)) + '</strong>' +
        '<span class="tws-row__meta">' + esc(meta.join(' · ')) + '</span><span class="tws-row__price">' + money(p.total) + '</span></div>' +
        '<div class="tws-row__acts">' +
        (model.swapChoices(ri).length > 1 ? '<button type="button" class="tws-mini" data-tws-swap="' + ri + '">Swap</button>' : '') +
        '<button type="button" class="tws-x" data-tws-remove="' + ri + '" aria-label="Remove ' + esc(plantName(p.plant)) + '">×</button></div></li>';
    });
    var full = inBox && !SIZES.some(function (s) { return model.roomFor(s); });
    html += '</ul>' + (full
      ? '<p class="tws-note">This box is full with ' + model.live().length + ' plants. Remove one to add another.</p>'
      : asIs && !model.suggested().length ? ''
      : '<button type="button" class="tws-more" data-tws-more><span aria-hidden="true">+</span> ' + esc(L.more || 'Add another plant') + '</button>') + '</div>';

    if (style && (every.repotCount || every.trayCount || every.standCount)) {
      html += '<div class="tws-step"><h2 class="tws-step__h"><span class="tws-step__n">3</span>' + esc(L.step3 || 'Finishing touches') + '</h2>';
      if (every.repotCount) {
        var choices = model.repotChoices(), pick = '';
        // the kinds of repotting, each with what it costs for this set (a plant size without a kind keeps the standard one)
        if (choices.length > 1 && model.repot) {
          var kindsName = L.repotKinds || 'Type of repotting';
          pick = '<div class="tws-kinds" role="radiogroup" aria-label="' + esc(kindsName) + '"><span class="tws-kinds__h">' + esc(kindsName) + '</span>' + choices.map(function (c) {
            var on = model.repotChoice ? c.label === model.repotChoice : c.first;
            return '<label class="tws-kind' + (on ? ' is-on' : '') + '"><input type="radio" name="tws-repot-kind" data-tws-repot-choice value="' + esc(c.first ? '' : c.label) + '"' + (on ? ' checked' : '') + '>' +
              '<span class="tws-kind__dot" aria-hidden="true"></span><span class="tws-kind__name">' + esc(c.label) + '</span><span class="tws-kind__price">' + money(model.repotCost(c.first ? '' : c.label)) + '</span></label>';
          }).join('') + '</div>';
        }
        html += check('data-tws-repot', model.repot, inBox ? (L.repotBox || 'Plant them into the box') : (L.repot || 'Repot each plant into its pot'), money(model.repot ? sums.repot : every.repot), inBox ? L.repotBoxNote : L.repotNote, pick);
      }
      if (every.trayCount) {
        html += check('data-tws-tray', model.tray, L.tray || 'Add matching trays', '+' + money(every.tray), (L.trayNote || '') + (every.trayCount < every.potCount ? ' For ' + every.trayCount + ' of the ' + every.potCount + ' pots.' : ''));
      }
      if (every.standCount) {
        var cols = model.standColours(), colNow = model.standColourNow(), colPick = '';
        if (cols.length > 1 && model.stand) {
          colPick = '<label class="tws-select"><span>' + esc(L.standColour || 'Stand colour') + '</span><select data-tws-stand-colour>' + cols.map(function (c) {
            return '<option value="' + esc(c) + '"' + (c === colNow ? ' selected' : '') + '>' + esc(c) + '</option>';
          }).join('') + '</select></label>';
        }
        // which sizes go in, in the stand options' own names: "medium - 18cm inner diameter x 2"
        var sizeNames = [], sizeCount = {};
        model.all(true).forEach(function (p) {
          if (!p.stand) return;
          if (sizeNames.indexOf(p.stand.size) < 0) sizeNames.push(p.stand.size);
          sizeCount[p.stand.size] = (sizeCount[p.stand.size] || 0) + 1;
        });
        var sizeText = sizeNames.map(function (n) { return n + (sizeCount[n] > 1 ? ' \u00d7 ' + sizeCount[n] : ''); }).join(', ');
        var standNote = String(L.standNote || '').trim();
        if (standNote && !/[.!?]$/.test(standNote)) standNote += '.';
        html += check('data-tws-stand', model.stand, L.stand || 'Wooden plant stand', '+' + money(every.stand),
          (standNote ? standNote + ' ' : '') + 'Fits ' + every.standCount + ' of the ' + every.potCount + ' pots' + (cols.length === 1 || model.stand ? ' in ' + colNow : '') + (sizeText ? ': ' + sizeText : '') + '.', colPick);
      }
      html += '</div>';
    }

    html += '<div class="tws-sum">' +
      '<div><span>' + sums.count + (asIs ? ' artificial' : '') + (sums.count === 1 ? ' plant' : ' plants') + '</span><span>' + money(sums.plants) + '</span></div>' +
      (sums.potCount ? '<div><span>' + (inBox ? '1 planter box' : sums.potCount + (sums.potCount === 1 ? ' pot' : ' pots')) + '</span><span>' + money(sums.pots) + '</span></div>' : '') +
      (sums.repotCount ? '<div><span>Repotting</span><span>' + money(sums.repot) + '</span></div>' : '') +
      (sums.trayCount ? '<div><span>' + sums.trayCount + (sums.trayCount === 1 ? ' tray' : ' trays') + '</span><span>' + money(sums.tray) + '</span></div>' : '') +
      (sums.standCount ? '<div><span>' + sums.standCount + (sums.standCount === 1 ? ' plant stand' : ' plant stands') + '</span><span>' + money(sums.stand) + '</span></div>' : '') +
      '<div class="tws-sum__total"><span>Set total</span><span>' + money(sums.total) + '</span></div></div>';
    if (model.hasPre()) {
      // the lead time of each kind of pre-order in the set (the product's tag: preorder-plants, -drop or -custom)
      var pres = model.all().filter(function (p) { return p.pre; }), kinds = [];
      var leadOf = function (k) {
        var own = k === 'drop' ? L.preDrop : k === 'custom' ? L.preCustom : L.preNote;
        // no lead time written for this kind yet: say no number rather than the plants' one
        return own || (k === 'plants' ? '' : 'This is ordered in for you, so it takes longer than our usual delivery. We share the lead time with you after you order. ') +
          'The whole order is delivered together once the pre-order is ready, so a delivery date cannot be picked in the cart.';
      };
      pres.forEach(function (p) {
        var k = p.plant.pk || 'plants', n = plantName(p.plant), g = kinds.filter(function (x) { return x.k === k; })[0];
        if (!g) { g = { k: k, names: [] }; kinds.push(g); }
        if (g.names.indexOf(n) < 0) g.names.push(n);
      });
      html += '<label class="tws-agree' + (model.agreed ? ' is-on' : '') + '"><input type="checkbox" data-tws-agree' + (model.agreed ? ' checked' : '') + '>' +
        '<span><strong>' + (pres.length === 1 ? '1 plant is a pre-order' : pres.length + ' plants are pre-orders') + '</strong>' +
        kinds.map(function (g) { return '<span class="tws-agree__lead">' + (kinds.length > 1 ? '<b>' + esc(g.names.join(', ')) + ':</b> ' : '') + esc(leadOf(g.k)) + '</span>'; }).join('') +
        '<em>' + esc(L.preAgree || 'I agree to this pre-order timeline.') + '</em></span></label>';
    }
    else if (L.note) html += '<p class="tws-note tws-note--center">' + esc(L.note) + '</p>';
    return html;
  }

  /* ------------------------------------------------------------------ the sheet (pots, swap, add a plant) */
  var sheet = null, sheetOn = null;
  function sheetEl() {
    if (sheet) return sheet;
    sheet = doc.createElement('div');
    sheet.className = 'tws-sheet';
    sheet.hidden = true;
    sheet.innerHTML = '<div class="tws-sheet__shade" data-tws-close></div><div class="tws-sheet__panel" role="dialog" aria-modal="true" tabindex="-1"></div>';
    doc.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-tws-close]')) { e.preventDefault(); closeSheet(); return; }
      if (sheetOn && sheetOn.click) sheetOn.click(e);
    });
    sheet.addEventListener('input', function (e) { if (sheetOn && sheetOn.input) sheetOn.input(e); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheetOn) closeSheet(); });
    return sheet;
  }
  function openSheet(title, sub, body, handlers) {
    var el = sheetEl(), panel = el.querySelector('.tws-sheet__panel');
    panel.setAttribute('aria-label', title);
    panel.innerHTML = '<div class="tws-sheet__grab" aria-hidden="true"></div><div class="tws-sheet__head"><h2>' + esc(title) + '</h2>' +
      '<button type="button" class="tws-x" data-tws-close aria-label="Close">×</button></div>' +
      (sub ? '<p class="tws-note">' + esc(sub) + '</p>' : '') + body;
    sheetOn = handlers || {};
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open');
    doc.documentElement.classList.add('tws-lock');
    panel.scrollTop = 0;
    try { panel.focus({ preventScroll: true }); } catch (e) {}
    return panel;
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    doc.documentElement.classList.remove('tws-lock');
    sheetOn = null;
    setTimeout(function () { if (!sheetOn) sheet.hidden = true; }, 220);
  }
  function optRow(p, attr, line, on) {
    // two plants can share a name once the size is dropped from it (ZZ Plant XL, ZZ Plant XXL): say the size
    var bit = plantBit(p.plant) || ((SIZE_WORD[p.size] || p.size) + ' plant');
    return '<button type="button" class="tws-opt' + (on ? ' is-on' : '') + '" ' + attr + ' aria-pressed="' + (on ? 'true' : 'false') + '">' + tileHtml(p, 56, 76, true) +
      '<span class="tws-opt__txt"><strong>' + esc(plantName(p.plant)) + '</strong><span>' + esc(bit) + '</span><em>' + esc(line) + '</em>' +
      (p.pre ? '<b class="tws-pre">Pre-order</b>' : '') + '</span>' +
      '<span class="tws-opt__dot" aria-hidden="true"></span></button>';
  }

  /* ------------------------------------------------------------------ adding to the cart, reading stock again */
  function addToCart(items) {
    if (!items.length) return Promise.reject(new Error('Add a plant first.'));
    if (window.cv3CartDrawer && window.cv3CartDrawer.add) return window.cv3CartDrawer.add({ items: items });
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error((d && (d.description || d.message)) || 'Could not add the set.'); return d; }); })
      .then(function (d) { location.href = '/cart'; return d; });
  }
  function readData(root) {
    var node = root.querySelector('script[data-tws-data]');
    try { return node ? JSON.parse(node.textContent) : null; } catch (e) { if (window.console) console.error('[plant sets] data', e); return null; }
  }
  function fresh(root) {
    var id = root.getAttribute('data-tws-section');
    if (!id) return Promise.resolve(null);
    return fetch(location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var box = doc.createElement('div');
        box.innerHTML = html;
        // the plant stands too: what is in stock now
        var stands = box.querySelector('script[data-cv3-stands]');
        if (stands && window.CV3_STANDS && window.CV3_STANDS.load) window.CV3_STANDS.load(stands);
        return readData(box);
      }).catch(function () { return null; });
  }
  // carry the shopper's choices over to a model made from newer data
  function carry(from, to) {
    to.agreed = from.agreed; to.bare = from.bare; to.repot = from.repot; to.repotChoice = from.repotChoice; to.tray = from.tray; to.stand = from.stand; to.standColour = from.standColour;
    to.rows = [];
    from.rows.forEach(function (row) {
      if (row.pi < 0) { if (row.o) to.rows.push({ pi: -1, o: row.o, label: row.label, size: row.size }); return; }
      var pl = to.set.places[row.pi];
      if (!pl) return;
      var same = row.o ? (pl.opts || []).filter(function (o) { return o.id === row.o.id && to.buyable(o) && to.free(o, -1); })[0] : null;
      to.rows.push({ pi: row.pi, o: same || null, label: pl.label, size: pl.size });
    });
    to.rows.forEach(function (row, i) { if (!row.o && row.pi >= 0) row.o = to.firstFree(row.pi, i); });
    var st = from.style();
    if (to.bare) { to.styleKey = ''; to.colour = ''; }
    else to.pickStyle(st ? st.name : '', from.colour);
  }

  /* ------------------------------------------------------------------ the page: every set as a card, one set opened */
  function initSets(root) {
    var data = readData(root);
    if (!data) return;
    var env = new Env(data), L = data.labels || {};
    var listEl = root.querySelector('[data-tws-list]'), holder = root.querySelector('[data-tws-cards]'), filters = root.querySelector('[data-tws-filters]');
    var oneEl = root.querySelector('[data-tws-one]'), bar = root.querySelector('[data-tws-bar]');
    var cards = [], cur = null, busy = false, msg = '', baseTitle = doc.title;
    if (!env.sets.length || !holder) return;

    function build() {
      holder.innerHTML = '';
      cards = env.sets.map(function (set) {
        var el = doc.createElement('article');
        el.className = 'tws-card';
        el.setAttribute('data-group', set.group || '');
        el.setAttribute('data-tws-card', set.handle);
        holder.appendChild(el);
        var model = new Model(set, env), ok = model.whole();
        el.hidden = !ok;
        return { set: set, model: model, el: el, busy: false, msg: '', ok: ok };
      });
    }
    function href(handle) {
      var u = new URL(location.href);
      if (handle) u.searchParams.set('set', handle); else u.searchParams.delete('set');
      return u.pathname + u.search;
    }
    function paintCard(card) {
      var model = card.model, set = card.set, sums = model.sums(), st = model.style();
      var names = model.all().map(function (p) { return plantName(p.plant); });
      if (model.box) names = counted(names);
      var cc = st ? colourChips(model) : { html: '' };
      var whole = sums.count > 0 && model.rows.every(function (r) { return !!r.o; }) && model.ready();
      // a set with a pre-order plant is added from its own page, where the shopper agrees to the pre-order
      var quick = whole && !model.hasPre();
      card.el.innerHTML =
        '<a class="tws-card__pic" href="' + esc(href(set.handle)) + '" data-tws-open="' + esc(set.handle) + '" aria-label="' + esc(set.name) + '">' +
          (set.badge ? '<span class="tws-card__badge">' + esc(set.badge) + '</span>' : '') +
          '<div class="tws-stage" data-tws-stage></div></a>' +
        '<div class="tws-card__body">' +
          '<div class="tws-card__top"><h3 class="tws-card__name"><a href="' + esc(href(set.handle)) + '" data-tws-open="' + esc(set.handle) + '">' + esc(set.name) + '</a></h3><span class="tws-card__price">' + money(sums.total) + '</span></div>' +
          '<p class="tws-card__names">' + esc(names.join(', ')) + '</p>' +
          '<p class="tws-card__what">' + sums.count + (model.plain ? ' artificial' : '') + (sums.count === 1 ? ' plant' : ' plants') + (model.box
            ? (st ? (sums.repotCount ? ' planted in one ' : ' with one ') + esc(st.name) : ', the planter box is sold out today')
            : model.plain ? '' : (st ? ' in ' + esc(st.name) + ' pots' + (sums.repotCount ? ', repotted' : '') : ' in nursery pots')) +
            (model.hasPre() ? ' <b class="tws-pre">Includes a pre-order</b>' : '') + '</p>' +
          (cc.html ? '<div class="tws-colours" role="group" aria-label="' + (model.box ? 'Box colour' : 'Pot colour') + '">' + cc.html + '<span class="tws-colours__name">' + esc(model.colour) + '</span></div>' : '') +
          '<div class="tws-card__acts">' +
            (quick ? '<button type="button" class="tws-btn" data-tws-quick>' + (card.busy ? 'Adding…' : esc(L.add || 'Add set')) + '</button>' : '') +
            '<a class="tws-btn tws-btn--line" href="' + esc(href(set.handle)) + '" data-tws-open="' + esc(set.handle) + '">' + esc(whole ? (L.open || 'Make it yours') : 'See this set') + '</a>' +
          '</div>' +
          (card.msg ? '<p class="tws-bar__msg" role="status">' + esc(card.msg) + '</p>' : '') +
        '</div>';
      drawStage(card.el.querySelector('[data-tws-stage]'), model, false);
    }
    function paintList() { cards.forEach(function (c) { if (!c.el.hidden) paintCard(c); }); }
    function paintFilters() {
      var groups = [];
      cards.forEach(function (c) { var s = c.set; if (c.ok && s.group && groups.indexOf(s.group) < 0) groups.push(s.group); });
      if (!filters || groups.length < 2) return;
      filters.hidden = false;
      filters.innerHTML = [''].concat(groups).map(function (g, i) {
        return '<button type="button" class="tws-chip' + (i ? '' : ' is-on') + '" data-tws-group="' + esc(g) + '" aria-pressed="' + (i ? 'false' : 'true') + '">' + esc(g || L.all || 'All') + '</button>';
      }).join('');
    }

    /* one set, opened */
    function skeleton() {
      var set = cur.set;
      oneEl.innerHTML = '<div class="tw__in tws__in">' +
        '<a class="tws-back" href="' + esc(href('')) + '" data-tws-back><span aria-hidden="true">←</span> ' + esc(L.back || 'All plant sets') + '</a>' +
        '<div class="tws__cols"><div class="tws__media">' +
          (set.photo ? '<div class="tws-tabs" role="group" aria-label="Pictures"><button type="button" class="tws-tab is-on" data-tws-view="set" aria-pressed="true">Your set</button><button type="button" class="tws-tab" data-tws-view="photo" aria-pressed="false">Room photo</button></div>' : '') +
          '<div class="tws-stage" data-tws-stage aria-live="polite"></div>' +
          (set.photo ? '<div class="tws-photo" data-tws-photo hidden><img src="' + esc(set.photo) + '" alt="' + esc(set.name) + '" loading="lazy">' + (L.photoNote ? '<p class="tws-photo__note">' + esc(L.photoNote) + '</p>' : '') + '</div>' : '') +
        '</div><div class="tws__body">' +
          '<h1 class="tw-h1 tws__title">' + esc(set.name) + '</h1>' +
          (set.tagline ? '<p class="tws__tagline">' + esc(set.tagline) + '</p>' : '') +
          (set.about ? '<p class="tws__lede">' + esc(set.about) + '</p>' : '') +
          '<div class="tws-app" data-tws-app></div>' +
        '</div></div></div>';
    }
    function paintOne() {
      if (!cur) return;
      var model = cur.model, sums = model.sums(), stage = oneEl.querySelector('[data-tws-stage]');
      if (stage && !stage.hidden) drawStage(stage, model, true);
      oneEl.querySelector('[data-tws-app]').innerHTML = appHtml(model, L);
      bar.hidden = false;
      bar.innerHTML = '<div class="tw__in tws-bar__in"><div class="tws-bar__total"><span>Set total</span><strong>' + money(sums.total) + '</strong></div>' +
        '<button type="button" class="tws-btn" data-tws-submit' + (model.canAdd() ? '' : ' disabled') + '>' + (busy ? 'Adding…' : esc(L.add || 'Add set')) + '</button></div>' +
        (msg ? '<p class="tws-bar__msg" role="status">' + esc(msg) + '</p>'
          : model.ready() && model.hasPre() && !model.agreed ? '<p class="tws-bar__msg">Tick the pre-order box above to add this set.</p>' : '');
    }
    function show(handle, push, jump) {
      var card = handle ? cards.filter(function (c) { return c.set.handle === handle; })[0] : null;
      if (push) { try { history.pushState({ twsSet: card ? handle : '' }, '', href(card ? handle : '')); } catch (e) {} }
      cur = card || null; busy = false; msg = '';
      root.classList.toggle('tws--one', !!cur);
      listEl.hidden = !!cur;
      oneEl.hidden = !cur;
      bar.hidden = !cur;
      if (cur) { skeleton(); paintOne(); doc.title = cur.set.name + ' | ' + baseTitle; }
      else { oneEl.innerHTML = ''; paintList(); doc.title = baseTitle; }
      if (jump) { try { window.scrollTo(0, Math.max(0, root.getBoundingClientRect().top + window.pageYOffset - 90)); } catch (e) {} }
    }
    function route(jump) {
      var want = '';
      try { want = new URLSearchParams(location.search).get('set') || ''; } catch (e) {}
      show(want, false, jump);
    }

    /* sheets */
    function stylesSheet() {
      var model = cur.model, now = model.style();
      var body = '<div class="tws-opts">' + model.fitStyles().map(function (st) {
        var ok = model.okColours(st), c = st === now ? model.colour : (ok.indexOf(model.colour) > -1 ? model.colour : ok[0]);
        var pic = potPic(model, st, c), sum = 0;
        model.live().forEach(function (r) { var h = model.hit(st, c, r.size); if (h) sum += h.v.p; });
        return '<button type="button" class="tws-opt' + (st === now ? ' is-on' : '') + '" data-tws-style="' + esc(st.key) + '" aria-pressed="' + (st === now ? 'true' : 'false') + '">' +
          '<span class="tws-opt__pot">' + pic + '</span>' +
          '<span class="tws-opt__txt"><strong>' + esc(st.name) + '</strong><span>' + esc(ok.join(', ')) + '</span><em>' + money(sum) + ' for the ' + model.live().length + ' pots</em></span>' +
          '<span class="tws-opt__dot" aria-hidden="true"></span></button>';
      }).join('') +
      (model.set.noPots ? '<button type="button" class="tws-opt' + (now ? '' : ' is-on') + '" data-tws-style="" aria-pressed="' + (now ? 'false' : 'true') + '"><span class="tws-opt__pot"></span>' +
        '<span class="tws-opt__txt"><strong>' + esc(L.noPots || 'No pots') + '</strong><span>' + esc(L.noPotsNote || 'Plants arrive in their nursery pots.') + '</span></span><span class="tws-opt__dot" aria-hidden="true"></span></button>' : '') +
      '</div>';
      openSheet('Choose the pots', 'Every plant gets the same style, in the size it needs.', body, { click: function (e) {
        var b = e.target.closest('[data-tws-style]');
        if (!b) return;
        var key = b.getAttribute('data-tws-style');
        if (!key) { model.bare = true; model.settle(); }
        else { model.bare = false; model.pickStyle(key, model.colour); }
        msg = ''; closeSheet(); paintOne();
      } });
    }
    function swapSheet(ri) {
      var model = cur.model, row = model.rows[ri], now = model.parts(row);
      var choices = model.swapChoices(ri);
      // a place of a planter box with several plants: one tap changes them all while stock lasts, unless unticked
      var mates = model.box && row.pi >= 0 ? model.rows.map(function (r, i) { return r.pi === row.pi ? i : -1; }).filter(function (i) { return i > -1; }) : [ri];
      var body = (mates.length > 1 ? '<label class="tws-allrow"><input type="checkbox" data-tws-swap-all checked><span>Same plant for all ' + mates.length + '</span></label>' : '') +
        '<div class="tws-opts">' + choices.map(function (o, i) {
        var p = model.quote(o, row.size, ri), on = now && o.id === now.plant.id, d = now ? o.p - now.plant.p : 0;
        var line = on ? 'In your set now' : (d === 0 ? 'Same price' : (d > 0 ? money(d) + ' more' : money(-d) + ' less'));
        if (mates.length > 1 && o.q < mates.length) line += ' · only ' + o.q + ' in stock';
        return optRow(p, 'data-tws-pick="' + i + '"', line, on);
      }).join('') + '</div><p class="tws-note">Only plants that can be ordered today are listed.</p>';
      var panel = openSheet('Swap the ' + String(row.label || 'plant').toLowerCase(), model.box ? 'Same size, so it keeps its place in the box.' : 'Same size, so it keeps its pot.', body, { click: function (e) {
        var b = e.target.closest('[data-tws-pick]');
        if (!b) return;
        var o = choices[Number(b.getAttribute('data-tws-pick'))], every = panel.querySelector('[data-tws-swap-all]');
        if (every && every.checked) {
          [ri].concat(mates.filter(function (i) { return i !== ri; })).forEach(function (i) { if (i === ri || model.free(o, i)) model.rows[i].o = o; });
        } else row.o = o;
        model.settle(); msg = ''; closeSheet(); paintOne();
      } });
    }
    function addSheet() {
      var model = cur.model, tab = 'set', q = '', shown = [], token = 0;
      // an artificial set offers only its own stand-ins and extras: the size lists are live plants
      var sizes = model.plain ? [] : SIZES.filter(function (s) { return (data.plantColl || {})[s] && model.sizeOk(s); });
      var body = '<div class="tws-find"><input type="search" data-tws-q placeholder="Search plants" aria-label="Search plants" autocomplete="off"></div>' +
        '<div class="tws-chips tws-chips--scroll" role="group" aria-label="Plant size">' +
        '<button type="button" class="tws-chip is-on" data-tws-tab="set" aria-pressed="true">Suggested</button>' +
        sizes.map(function (s) { return '<button type="button" class="tws-chip" data-tws-tab="' + s + '" aria-pressed="false">' + esc(SIZE_WORD[s]) + '</button>'; }).join('') +
        '</div><div class="tws-opts" data-tws-results></div>';
      var panel = openSheet(L.more || 'Add another plant', model.box ? 'It goes into the same planter box.' : model.plain ? '' : (model.style() ? 'Each one gets a ' + model.style().name + ' pot to match the rest of your set.' : 'Plants arrive in their nursery pots.'), body, {
        click: function (e) {
          var b = e.target.closest('[data-tws-tab]');
          if (b) {
            tab = b.getAttribute('data-tws-tab');
            each(panel.querySelectorAll('[data-tws-tab]'), function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
            load();
            return;
          }
          b = e.target.closest('[data-tws-addpick]');
          if (!b) return;
          var o = shown[Number(b.getAttribute('data-tws-addpick'))];
          if (!o) return;
          model.add(o, o.size);
          msg = ''; closeSheet(); paintOne();
        },
        input: function (e) {
          if (!e.target.matches || !e.target.matches('[data-tws-q]')) return;
          q = norm(e.target.value);
          draw();
        }
      });
      var results = panel.querySelector('[data-tws-results]'), pool = [];
      function draw() {
        shown = pool.filter(function (o) { return !q || norm(o.title).indexOf(q) > -1; }).slice(0, 40);
        if (!shown.length) {
          results.innerHTML = '<p class="tws-note">' + (q ? 'No plant with that name here. Try another size above.' : (tab === 'set' ? 'Pick a size above to see more plants.' : 'Nothing in this size can be added right now.')) + '</p>';
          return;
        }
        results.innerHTML = shown.map(function (o, i) {
          var p = model.quote(o, o.size);
          var line = '+' + money(p.total) + (p.potVar ? ' with its pot' + (p.repot ? ' and repotting' : '') : (p.box && p.repot ? ' with repotting' : ''));
          return optRow(p, 'data-tws-addpick="' + i + '"', line, false);
        }).join('');
      }
      function load() {
        var mine = ++token;
        if (tab === 'set') { pool = model.suggested(); draw(); return; }
        results.innerHTML = '<p class="tws-note">Loading plants…</p>';
        env.plants(tab).then(function (list) {
          if (mine !== token) return;
          pool = list.filter(function (o) { return model.buyable(o) && model.free(o, -1); });
          pool = pool.filter(function (o) { return model.stockLeft(o, -1) > 0; }).concat(pool.filter(function (o) { return model.stockLeft(o, -1) <= 0; }));
          draw();
        });
      }
      load();
    }

    function submit() {
      if (busy || !cur || !cur.model.canAdd()) return;
      busy = true; msg = ''; paintOne();
      addToCart(cur.model.items()).then(function () {
        busy = false; msg = 'Added to your cart.'; paintOne();
      }).catch(function (err) { recover(err, cur, function (text) { busy = false; msg = text; paintOne(); }); });
    }
    // an add failed, most likely because something sold out a moment ago: read stock again, keep the choices
    function recover(err, card, done) {
      var sig = function (m) { return m.rows.map(function (r) { return r.o ? r.o.id : 0; }).join(',') + '|' + m.styleKey + '|' + m.colour; };
      var before = sig(card.model), why = (err && err.message) || '';
      fresh(root).then(function (d) {
        if (!d) { done(why || 'Could not add the set. Please try again.'); return; }
        var next = new Env(d), handle = card.set.handle, was = cards;
        env = next; data = d; L = d.labels || L;
        build();
        cards.forEach(function (c) {
          var old = was.filter(function (x) { return x.set.handle === c.set.handle; })[0];
          if (old) carry(old.model, c.model);
        });
        cur = cur ? (cards.filter(function (c) { return c.set.handle === handle; })[0] || null) : null;
        // the set is as it was, so stock did not change it: give the cart's own reason (most often the cart
        // already holds all there is of a plant)
        var now = cards.filter(function (c) { return c.set.handle === handle; })[0];
        if (now && sig(now.model) === before && why && !/^add failed$|invalid add payload/i.test(why)) { done(why); return; }
        done('Stock changed a moment ago, so we updated the set. Please check it and add again.');
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target, b;
      if ((b = t.closest('[data-tws-open]'))) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
        e.preventDefault(); show(b.getAttribute('data-tws-open'), true, true); return;
      }
      if (t.closest('[data-tws-back]')) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
        e.preventDefault(); show('', true, true); return;
      }
      if ((b = t.closest('[data-tws-group]'))) {
        var g = b.getAttribute('data-tws-group');
        each(filters.querySelectorAll('[data-tws-group]'), function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        cards.forEach(function (c) { c.el.hidden = !c.ok || (!!g && c.el.getAttribute('data-group') !== g); });
        paintList(); return;
      }
      var cardEl = t.closest('[data-tws-card]');
      if (cardEl) {
        var card = cards.filter(function (c) { return c.el === cardEl; })[0];
        if (!card) return;
        if ((b = t.closest('[data-tws-colour]'))) {
          e.preventDefault();
          if (b.getAttribute('aria-disabled') === 'true') return;
          card.model.pickStyle(card.model.style() ? card.model.style().name : '', b.getAttribute('data-tws-colour'));
          card.msg = ''; paintCard(card); return;
        }
        if (t.closest('[data-tws-quick]')) {
          if (card.busy) return;
          card.busy = true; card.msg = ''; paintCard(card);
          addToCart(card.model.items()).then(function () { card.busy = false; card.msg = 'Added to your cart.'; paintCard(card); })
            .catch(function (err) { recover(err, card, function (text) { var c2 = cards.filter(function (c) { return c.set.handle === card.set.handle; })[0]; paintFilters(); paintList(); if (c2) { c2.msg = text; paintCard(c2); } }); });
        }
        return;
      }
      if (!cur) return;
      var model = cur.model;
      if ((b = t.closest('[data-tws-view]'))) {
        var view = b.getAttribute('data-tws-view'), photo = oneEl.querySelector('[data-tws-photo]'), stage = oneEl.querySelector('[data-tws-stage]');
        each(oneEl.querySelectorAll('[data-tws-view]'), function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        if (photo) photo.hidden = view !== 'photo';
        stage.hidden = view === 'photo';
        if (view !== 'photo') drawStage(stage, model, true);
        return;
      }
      if ((b = t.closest('[data-tws-colour]'))) {
        if (b.getAttribute('aria-disabled') === 'true') return;
        model.pickStyle(model.style() ? model.style().name : '', b.getAttribute('data-tws-colour')); msg = ''; paintOne(); return;
      }
      if (t.closest('[data-tws-styles]')) { stylesSheet(); return; }
      if ((b = t.closest('[data-tws-swap]'))) { swapSheet(Number(b.getAttribute('data-tws-swap'))); return; }
      if ((b = t.closest('[data-tws-remove]'))) { model.rows.splice(Number(b.getAttribute('data-tws-remove')), 1); model.settle(); msg = ''; paintOne(); return; }
      if (t.closest('[data-tws-more]')) { addSheet(); return; }
      if (t.closest('[data-tws-submit]')) { submit(); return; }
    });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!cur || !t || !t.matches) return;
      if (t.matches('[data-tws-repot]')) cur.model.repot = !!t.checked;
      else if (t.matches('[data-tws-tray]')) cur.model.tray = !!t.checked;
      else if (t.matches('[data-tws-stand]')) cur.model.stand = !!t.checked;
      else if (t.matches('[data-tws-repot-choice]')) cur.model.repotChoice = t.value || '';
      else if (t.matches('[data-tws-stand-colour]')) cur.model.standColour = t.value || '';
      else if (t.matches('[data-tws-agree]')) cur.model.agreed = !!t.checked;
      else return;
      msg = ''; paintOne();
    });
    window.addEventListener('popstate', function () { route(false); });
    var timer = null;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (cur) { var stage = oneEl.querySelector('[data-tws-stage]'); if (stage && !stage.hidden) drawStage(stage, cur.model, true); }
        else cards.forEach(function (c) { if (!c.el.hidden) drawStage(c.el.querySelector('[data-tws-stage]'), c.model, false); });
      }, 150);
    });

    build();
    paintFilters();
    route(false);
  }

  function start() {
    each(doc.querySelectorAll('[data-tws="sets"]'), function (root) {
      if (root.__tws) return;
      root.__tws = 1;
      try { initSets(root); } catch (e) { if (window.console) console.error('[plant sets]', e); }
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
  doc.addEventListener('shopify:section:load', start);
})();
